import { Nav } from "react-bootstrap"
import { Link } from "react-router-dom"

const CertificateNavTab = ({ eventKey="", to="", text="" }) => {

    return (
        <Nav.Item>
            <Nav.Link as={Link} eventKey={eventKey} to={to} className="text-light py-1 border-1 border-dark rounded-0">
                {text}
            </Nav.Link>
        </Nav.Item>
    );
};


export default CertificateNavTab;